import { fetchApi } from '@/config/axiosSetting';
import { PatchContactOwnerFormQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/culprit/patchContactOwnerForm/patchContactOwnerFormQuery.type';

export const patchContactOwnerFormFunction = (
  params: PatchContactOwnerFormQueryParamsType,
) => {
  return fetchApi.patch(
    `property/reports/${params?.id}/accident_users/culprit/user_information/owner/contact_information/`,
    params?.data,
    {
      params: {
        id: params?.id,
      },
    },
  );
};
